export default __webpack_public_path__ + "static/media/1-front-people.82908a9d.png";